import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import panelStyles from "../../styles/components/profile/MessagesPanel.module.css";

const MessagesPanelSkeleton = ({ variant = "standalone" }) => {
  return (
    <div
      className={`${panelStyles.messagesWrapper} ${
        variant === "embedded" ? panelStyles.embedded : ""
      }`}
    >
      <div className={panelStyles.messagesContainer}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "260px 1fr",
          width: "100%",
          minHeight: "480px",
        }}
      >
        <div
          style={{
            borderRight: "1px solid var(--color-border)",
            padding: "16px",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <Skeleton height={28} width="140px" />
          <Skeleton height={36} width="100%" borderRadius={8} />
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {[1, 2, 3, 4, 5].map((i) => (
            <div
              key={i}
              style={{
                padding: "15px",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                display: "flex",
                gap: "12px",
                alignItems: "center",
              }}
            >
              <Skeleton circle height={50} width={50} />
              <div style={{ flex: 1 }}>
                <Skeleton
                  height={18}
                  width="70%"
                  style={{ marginBottom: "5px" }}
                />
                <Skeleton height={14} width="90%" />
              </div>
            </div>
          ))}
          </div>
        </div>

        <div
          style={{
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            minHeight: "480px",
          }}
        >
          {/* Conversation Header */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              paddingBottom: "15px",
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            <Skeleton circle height={40} width={40} />
            <div style={{ flex: 1 }}>
              <Skeleton
                height={20}
                width="150px"
                style={{ marginBottom: "5px" }}
              />
              <Skeleton height={14} width="80px" />
            </div>
          </div>

          {/* Messages Area */}
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              gap: "15px",
              padding: "20px 0",
            }}
          >
            {/* Received message */}
            <div
              style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}
            >
              <Skeleton circle height={32} width={32} />
              <div style={{ maxWidth: "60%" }}>
                <Skeleton height={50} width="250px" borderRadius={12} />
                <Skeleton
                  height={12}
                  width="80px"
                  style={{ marginTop: "5px" }}
                />
              </div>
            </div>

            {/* Sent message */}
            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "flex-start",
                marginLeft: "auto",
              }}
            >
              <div style={{ maxWidth: "60%", textAlign: "right" }}>
                <Skeleton height={50} width="300px" borderRadius={12} />
                <Skeleton
                  height={12}
                  width="80px"
                  style={{ marginTop: "5px", marginLeft: "auto" }}
                />
              </div>
              <Skeleton circle height={32} width={32} />
            </div>

            {/* Received message */}
            <div
              style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}
            >
              <Skeleton circle height={32} width={32} />
              <div style={{ maxWidth: "60%" }}>
                <Skeleton height={60} width="280px" borderRadius={12} />
                <Skeleton
                  height={12}
                  width="80px"
                  style={{ marginTop: "5px" }}
                />
              </div>
            </div>

            {/* Sent message */}
            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "flex-start",
                marginLeft: "auto",
              }}
            >
              <div style={{ maxWidth: "60%", textAlign: "right" }}>
                <Skeleton height={40} width="200px" borderRadius={12} />
                <Skeleton
                  height={12}
                  width="80px"
                  style={{ marginTop: "5px", marginLeft: "auto" }}
                />
              </div>
              <Skeleton circle height={32} width={32} />
            </div>
          </div>

          {/* Message Input */}
          <div
            style={{
              display: "flex",
              gap: "10px",
              paddingTop: "15px",
              borderTop: "1px solid #e5e7eb",
            }}
          >
            <Skeleton height={44} width="100%" borderRadius={22} />
            <Skeleton height={44} width={60} borderRadius={22} />
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default MessagesPanelSkeleton;
